export class FcpError extends Error {
  constructor(message: string) {
    super(message);

    Object.setPrototypeOf(this, FcpError.prototype);
  }
}
